"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Variant = require("./Variant.utils");
var _Variant2 = _interopRequireDefault(require("./Variant.context"));
var _ManualVariant = _interopRequireDefault(require("./ManualVariant"));
class Variant extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "checkForCookies", () => {
      let newVariants = (0, _Variant.getVariantsFromCookies)(this.props.cookieIds);
      if (newVariants !== this.state.variants) {
        this.setState({
          variants: newVariants
        });
      }
    });
    this.state = {
      variants: this.props.triggerType === "cookies" ? (0, _Variant.getVariantsFromCookies)(props.cookieIds) : (0, _Variant.getVariantsFromQueryParams)(),
      areMultipleChildren: this.props.children.length !== undefined
    };
    this.cookieInterval = null;
    this.killInterval = null;
  }
  componentDidMount() {
    if (this.props.triggerType === "cookies") {
      // because vwo cookies don't show up until after initial load (for new members, or expired sessions, etc.),
      // we need to check for them to be set.. checks every half second, for 15 seconds, then stops.
      // once Edge supports document.cookies.onChange events, switch to that.
      this.cookieInterval = setInterval(this.checkForCookies, 500); // run every 100 ms
      this.killInterval = setInterval(() => {
        clearInterval(this.cookieInterval);
        clearInterval(this.killInterval);
      }, 15000);
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_Variant2.default.Provider, {
      value: this.state.variants
    }, /*#__PURE__*/_react.default.createElement(_ManualVariant.default, null), this.props.children);
  }
}
exports.default = Variant;
Variant.propTypes = {
  /** HTML Button Type attribute [submit, button] */
  triggerType: _propTypes.default.oneOf(["queryParams", "cookies"]),
  /** Array of cookie names to grab variants from */
  cookieIds: _propTypes.default.array
};
Variant.defaultProps = {
  triggerType: "queryParams",
  cookieIds: []
};